<template>
  <div class="_order-status-label">
    <span
      class="d-inline-block"
      :class="color"
      style="width: 10px; height: 10px; border-radius: 50%;">
    </span>
    {{ statusText }}
  </div>
</template>

<script>
const STATUS_COLORS = {
  new: 'error',
  pending: '_pending-status-color',
  paid: 'info',
  completed: 'primary',
  rejected: 'black',
  deleted: 'grey'
}

const STATUS_TEXTS = {
  new: 'ยังไม่ได้ชำระเงิน',
  pending: 'รอการตรวจสอบ',
  paid: 'กำลังดำเนินการ',
  completed: 'ดำเนินการเรียบร้อย',
  rejected: 'ถูกปฏิเสธ',
  deleted: 'ไม่สามารถใช้งานได้'
}

export default {
  name: 'OrderStatusLabel',
  props: {
    status: {
      type: String,
      default: ''
    },
    withholdingTaxStatus: {
      type: String,
      default: ''
    },
    deletedType: {
      type: String,
      default: ''
    },
    isJuristicCustomer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusDisplay () {
      if (this.isJuristicCustomer) {
        return this.getJuristicStatusDisplay()
      }
      return this.getNonJuristicStatusDisplay()
    },
    color () {
      return this.statusDisplay.color
    },
    statusText () {
      return this.statusDisplay.text
    }
  },
  methods: {
    getJuristicStatusDisplay () {
      // Juristic: withholdingTaxStatus takes priority
      if (this.withholdingTaxStatus === 'rejected') {
        return { color: 'black', text: 'เอกสารไม่ถูกต้อง' }
      }

      if (this.withholdingTaxStatus === 'pending') {
        return { color: 'info', text: 'กำลังดำเนินการ' }
      }

      return this.getBaseStatusDisplay()
    },

    getNonJuristicStatusDisplay () {
      // Non-juristic: follow order.status only
      return this.getBaseStatusDisplay()
    },

    getBaseStatusDisplay () {
      // Handle special case: user cancelled order
      if (this.status === 'deleted' && this.deletedType === 'userCancel') {
        return { color: STATUS_COLORS.deleted, text: 'ยกเลิกรายการสั่งซื้อ' }
      }

      return {
        color: STATUS_COLORS[this.status],
        text: STATUS_TEXTS[this.status]
      }
    }
  }
}
</script>

<style scoped>
._pending-status-color {
  background-color: #F9DB05;
}
</style>
